import React, { useEffect, useCallback, useState } from 'react';
import axios from '../../../shared/axios/axiosProxy.js';
import ACTIONS from '../../../redux/action.js';
import { useSelector, useDispatch } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { loadStripe } from '@stripe/stripe-js';
import rocketman from '../../../images/Rocketman.png';
import blueaccountant from '../../../images/BlueAccountant.png';
import peaking4 from '../../../images/peaking4.png';
import i18n from '../../../utils/i18n.js';
import {
    EmbeddedCheckoutProvider,
    EmbeddedCheckout
} from '@stripe/react-stripe-js';
import './payment.scss';
import CheckoutReturn from './CheckoutReturn.jsx';
const stripePromise = loadStripe(`${process.env.REACT_APP_STRIPE_PUBLIC_KEY}`);

const StripeCheckout = ({ priceId }) => {
    const companyStore = useSelector((state) => state.company_store);
    const [checkoutComplete, setCheckoutComplete] = useState(false);
    const dispatch = useDispatch();

    const fetchClientSecret = useCallback(async () => {
        // Create a Checkout Session
        return await axios
            .post('/api/checkout/session', {
                email: companyStore.email,
                priceId: priceId,
                reqId: companyStore.reqID
            })
            .then((response) => {
                console.log('RESPONSE', response.data);
                dispatch(
                    ACTIONS.addCompanyInfo({
                        id: 'stripeSessionId',
                        data: response.data.id,
                        stateObject: 'company_store',
                    })
                );
                return response.data.clientSecret;
            })
            .catch((error) => {
                console.log('AXIOS ERROR: ', error.response?.data || error.message);
            });
    }, [companyStore.reqID, companyStore.email]);

    useEffect(() => {
        if (!companyStore.checkoutComplete) {
            setCheckoutComplete(false);
        }
    }, [companyStore.checkoutComplete])

    const onComplete = async () => {
        setTimeout(() => {
            setCheckoutComplete(true);
        }, 1000);
    };

    const options = { fetchClientSecret, onComplete };

    const headerText = checkoutComplete ? i18n.t('searchflow.bookConsultation') : i18n.t('searchflow.providePaymentDetails');

    return (
        <div className={'payment-container'}>
            <div className='payment-left-info-area'>
                <img
                    src={rocketman}
                    alt='RocketMan'
                    className='rocket-man'
                />
            </div>
            <div className={'payment-content-area'}>
                <>
                    {
                        <div className='payment-content-header'>
                            <div>
                                <p className='payment-header-subtext'>{i18n.t('searchflow.sfresulttext2')}</p>
                                <p>{headerText}</p>
                            </div>
                            <div>
                                <img
                                    className='header-img'
                                    alt='header'
                                    src={peaking4}
                                />
                            </div>
                        </div>
                    }

                    <div id="checkout">
                        {!checkoutComplete ? (
                            <EmbeddedCheckoutProvider
                                stripe={stripePromise}
                                options={options}
                            >
                                <EmbeddedCheckout />
                            </EmbeddedCheckoutProvider>
                        ) : <CheckoutReturn />}
                    </div>
                </>
            </div>
            <div className='payment-right-info-area'>
                <img
                    src={blueaccountant}
                    alt='Accountant lady'
                    className='blue-accountant'
                />
            </div>
        </div>
    )
}

export default withTranslation()(StripeCheckout);